import React, { Fragment } from 'react';
import Menu from "semantic-ui-react/dist/es/collections/Menu/Menu.js";
import { size } from "../../../../utils/size";
import { buildKeyFromStrings } from "../../../../utils/build-key-from-strings";
import { Button } from "../../../elements/Button";
import { Submenu } from "../../../elements/Submenu";
import { getSubmenuPointing } from "./getSubmenuPointing";
import { getLinkMarkup } from "./getLinkMarkup";
export var getStandardMenuMarkup = function getStandardMenuMarkup(_ref, activeNavigationItemIndex) {
  var navigationItems = _ref.navigationItems,
      primaryCTA = _ref.primaryCTA;
  return React.createElement(Fragment, null, navigationItems.map(function (_ref2, index) {
    var subItems = _ref2.subItems,
        text = _ref2.text,
        href = _ref2.href,
        target = _ref2.target;
    return size(subItems) > 0 ? React.createElement(Submenu, {
      isMenuItem: true,
      isSimple: true,
      isTriggerUnderlined: index === activeNavigationItemIndex,
      isTriggeredOnHover: true,
      items: subItems,
      key: buildKeyFromStrings(text, index),
      pointing: getSubmenuPointing(index, size(navigationItems), !!primaryCTA)
    }, text) : getLinkMarkup(text, href, target, index, activeNavigationItemIndex);
  }), primaryCTA && React.createElement(Menu.Item, {
    className: "no-underline",
    link: true
  }, React.createElement(Button, {
    isRounded: true,
    onClick: primaryCTA.onClick
  }, primaryCTA.text)));
};